import { gql } from "@apollo/client";

export const GET_PROPERTIES = gql`
  query GetProperties($pageOptions: PageOptions, $filters: [Filters]) {
    getProperties(pageOptions: $pageOptions, filters: $filters) {
      properties {
        arcimedes_row_id
        deleted
        source
        transaction_type
        status
        visible
        featured
        strive_slider
        name
        address
        city
        state
        zip
        latitude
        longitude
        highlights
        media_kit
        type
        sqft
        list_price
        net_operating_income
        vacancy
        capitalization_rate
        sold_price
        down_payment
        close_of_escrow
        listed_date
        seller_fee_percentage
        total_fee
        lease_type
        lease_commencement_date
        lease_expiration_date
        seller_id
        buyer_id
        year_built
        video_url
        close_noi
        proforma_noi
        proforma_base_rent
        proforma_cap_rate
        close_cap_rate
        close_price_per_sqft
        price_per_sqft
        listing_agent_1
        listing_agent_2
        listing_agent_3
        listing_agent_4
        referring_listing_agent
        listing_agent_4_firm
        referring_listing_agent_firm
        buyer_agent_1
        buyer_agent_2
        buyer_agent_3
        buyer_agent_4
        referring_buyer_agent
        buyer_agent_4_firm
        referring_buyer_agent_firm
        listing_agent_1_percent
        listing_agent_2_percent
        listing_agent_3_percent
        listing_agent_4_percent
        referring_listing_agent_percent
        buyer_agent_1_percent
        buyer_agent_2_percent
        buyer_agent_3_percent
        buyer_agent_4_percent
        referring_buyer_agent_percent
        single_tenant_subcategory
        multi_tenant_subcategory
        tenant_id
        market
        rent_per_sqft
        negotiation_price
        potential_fee
        list_fee
        buyside_fee
        negotiation_cap_rate
        category
        hide_financials
        is_proforma_pricing
        date_removed
        negotiation_price_per_sqft
        base_rent
        expiration_no_of_months
        expiration_date
        effective_date
        referral_fee
        hsc_team_member_1
        hsc_team_member_1_percent
        hsc_team_member_1_net_fee
        hsc_team_member_1_net_percent
        hsc_team_member_1_gross_fee
        hsc_team_member_2
        hsc_team_member_2_percent
        hsc_team_member_2_net_fee
        hsc_team_member_2_net_percent
        hsc_team_member_2_gross_fee
        hsc_agreement_file
        loan_commitment_file
        closing_statement_file
        loan_closing_date
        hsc_approved
        hsc_approved_timestamp
        hsc_approved_initials
        hsc_status
        hsc_price
        hsc_listed_date
        hsc_expiration_no_of_months
        hsc_expiration_date
        hsc_fee_percentage
        hsc_total_fee
        hsc_list_fee
        lender_id
        loan_type
        ltv
        loan_amount
        interest_rate
        amortization
        term
        maturity_date
        annual_loan_payment
        cash_flow
        cash_on_cash
        dscr
        prepayment_penalty
        credits_at_closing
        referral
        referral_percent
        noi_percent
        referred_by_id
        referred_by_type
        referral_type
        hsc_financing
        date_created
        apn
        other_financing
        notes
        rep_agreement_file_1
        rep_agreement_file_2
        rep_agreement_file_3
        rep_agreement_file_4
        rep_agreement_file_5
        in_neg_file_1
        in_neg_file_2
        in_neg_file_3
        in_neg_file_4
        in_neg_file_5
        seller_statement_file
        buyer_statement_file
        website_photo_1
        website_photo_2
        website_photo_3
        website_photo_4
        website_photo_5
        created_by
        flagged_date
        under_contract_in_negotiation_since
        property_info_since
        off_market_since
        last_modified_by
        last_modified_date
        uploaded_from
        is_listing
        was_proposal
        estimated_price_type
        sub_category
        units
        proposal_date
        bank_bonus
        bank_bonus_percent
        arcimedes_created
        arcimedes_created_by
        arcimedes_modified
        arcimedes_modified_by
        agent_1_first_name
        agent_1_last_name
        agent_2_first_name
        agent_2_last_name
        agent_3_first_name
        agent_3_last_name
        agent_4_first_name
        agent_4_last_name
        sellers_first_name
        sellers_last_name
        lender_name
      }
      totalCount
    }
  }
`;
export const GET_PROPERTIES_FOR_STATSCOLUMNS = gql`
query GetProperties($pageOptions: PageOptions, $filters: [Filters], $sortOptions: [SortOptions]) {
  getProperties(pageOptions: $pageOptions, filters: $filters, sortOptions: $sortOptions) {
    properties {
      arcimedes_row_id
      deleted
      source
      transaction_type
      status
      visible
      featured
      strive_slider
      name
      address
      city
      state
      zip
      latitude
      longitude
      highlights
      media_kit
      type
      sqft
      list_price
      net_operating_income
      vacancy
      capitalization_rate
      sold_price
      down_payment
      close_of_escrow
      listed_date
      seller_fee_percentage
      total_fee
      lease_type
      lease_commencement_date
      lease_expiration_date
      seller_id
      buyer_id
      year_built
      video_url
      close_noi
      proforma_noi
      proforma_base_rent
      proforma_cap_rate
      close_cap_rate
      close_price_per_sqft
      price_per_sqft
      listing_agent_1
      listing_agent_2
      listing_agent_3
      listing_agent_4
      referring_listing_agent
      listing_agent_4_firm
      referring_listing_agent_firm
      buyer_agent_1
      buyer_agent_2
      buyer_agent_3
      buyer_agent_4
      referring_buyer_agent
      buyer_agent_4_firm
      referring_buyer_agent_firm
      listing_agent_1_percent
      listing_agent_2_percent
      listing_agent_3_percent
      listing_agent_4_percent
      referring_listing_agent_percent
      buyer_agent_1_percent
      buyer_agent_2_percent
      buyer_agent_3_percent
      buyer_agent_4_percent
      referring_buyer_agent_percent
      single_tenant_subcategory
      multi_tenant_subcategory
      tenant_id
      market
      rent_per_sqft
      negotiation_price
      potential_fee
      list_fee
      buyside_fee
      negotiation_cap_rate
      category
      hide_financials
      is_proforma_pricing
      date_removed
      negotiation_price_per_sqft
      base_rent
      expiration_no_of_months
      expiration_date
      effective_date
      referral_fee
      hsc_team_member_1
      hsc_team_member_1_percent
      hsc_team_member_1_net_fee
      hsc_team_member_1_net_percent
      hsc_team_member_1_gross_fee
      hsc_team_member_2
      hsc_team_member_2_percent
      hsc_team_member_2_net_fee
      hsc_team_member_2_net_percent
      hsc_team_member_2_gross_fee
      hsc_agreement_file
      loan_commitment_file
      closing_statement_file
      loan_closing_date
      hsc_approved
      hsc_approved_timestamp
      hsc_approved_initials
      hsc_status
      hsc_price
      hsc_listed_date
      hsc_expiration_no_of_months
      hsc_expiration_date
      hsc_fee_percentage
      hsc_total_fee
      hsc_list_fee
      lender_id
      loan_type
      ltv
      loan_amount
      interest_rate
      amortization
      term
      maturity_date
      annual_loan_payment
      cash_flow
      cash_on_cash
      dscr
      prepayment_penalty
      credits_at_closing
      referral
      referral_percent
      noi_percent
      referred_by_id
      referred_by_type
      referral_type
      hsc_financing
      date_created
      apn
      other_financing
      notes
      rep_agreement_file_1
      rep_agreement_file_2
      rep_agreement_file_3
      rep_agreement_file_4
      rep_agreement_file_5
      in_neg_file_1
      in_neg_file_2
      in_neg_file_3
      in_neg_file_4
      in_neg_file_5
      seller_statement_file
      buyer_statement_file
      website_photo_1
      website_photo_2
      website_photo_3
      website_photo_4
      website_photo_5
      created_by
      flagged_date
      under_contract_in_negotiation_since
      property_info_since
      off_market_since
      last_modified_by
      last_modified_date
      uploaded_from
      is_listing
      was_proposal
      estimated_price_type
      sub_category
      units
      proposal_date
      bank_bonus
      bank_bonus_percent
      arcimedes_created
      arcimedes_created_by
      arcimedes_modified
      arcimedes_modified_by
      agent_1_first_name
      agent_1_last_name
      agent_2_first_name
      agent_2_last_name
      agent_3_first_name
      agent_3_last_name
      agent_4_first_name
      agent_4_last_name
      sellers_first_name
      sellers_last_name
      lender_name
    }
    totalCount
  }
}
`;


export const GET_ALL_PROPERTIES = gql`
query getAllProperties($source: [String]!, $latitude: String!, $longitude: String!) {
  getAllProperties(source: $source, latitude: $latitude, longitude: $longitude) 
}`
// {
//     arcimedes_row_id
//     source
//     status
//     transaction_type
//     latitude
//     longitude
//     seller_id
//     buyer_id
//     name
//   }
export const V7_PROPERTIES_LIST_DEV = gql`
query V7PropertiesList($listOptions: ListOptions, $sortOptions: [SortOptions]) {
  v7PropertiesList(listOptions: $listOptions, sortOptions: $sortOptions) {
    arcimedes_row_id
    deleted
    source
    transaction_type
    status
    visible
    featured
    strive_slider
    name
    address
    city
    state
    zip
    latitude
    longitude
    lot_size
    highlights
    media_kit
    type
    sqft
    list_price
    net_operating_income
    vacancy
    capitalization_rate
    sold_price
    down_payment
    close_of_escrow
    listed_date
    seller_fee_percentage
    total_fee
    lease_type
    lease_commencement_date
    lease_expiration_date
    seller_id
    buyer_id
    year_built
    video_url
    close_noi
    proforma_noi
    proforma_base_rent
    proforma_cap_rate
    close_cap_rate
    close_price_per_sqft
    price_per_sqft
    listing_agent_1
    listing_agent_2
    listing_agent_3
    listing_agent_4
    referring_listing_agent
    listing_agent_4_firm
    referring_listing_agent_firm
    buyer_agent_1
    buyer_agent_2
    buyer_agent_3
    buyer_agent_4
    referring_buyer_agent
    buyer_agent_4_firm
    referring_buyer_agent_firm
    listing_agent_1_percent
    listing_agent_2_percent
    listing_agent_3_percent
    listing_agent_4_percent
    referring_listing_agent_percent
    buyer_agent_1_percent
    buyer_agent_2_percent
    buyer_agent_3_percent
    buyer_agent_4_percent
    referring_buyer_agent_percent
    single_tenant_subcategory
    multi_tenant_subcategory
    tenant_id
    market
    rent_per_sqft
    negotiation_price
    potential_fee
    list_fee
    buyside_fee
    negotiation_cap_rate
    category
    hide_financials
    is_proforma_pricing
    date_removed
    negotiation_price_per_sqft
    base_rent
    expiration_no_of_months
    expiration_date
    effective_date
    referral_fee
    hsc_team_member_1
    hsc_team_member_1_percent
    hsc_team_member_1_net_fee
    hsc_team_member_1_net_percent
    hsc_team_member_1_gross_fee
    hsc_team_member_2
    hsc_team_member_2_percent
    hsc_team_member_2_net_fee
    hsc_team_member_2_net_percent
    hsc_team_member_2_gross_fee
    hsc_agreement_file
    loan_commitment_file
    closing_statement_file
    loan_closing_date
    hsc_approved
    hsc_approved_timestamp
    hsc_approved_initials
    hsc_status
    hsc_price
    hsc_listed_date
    hsc_expiration_no_of_months
    hsc_expiration_date
    hsc_fee_percentage
    hsc_total_fee
    hsc_list_fee
    lender_id
    loan_type
    ltv
    loan_amount
    interest_rate
    amortization
    term
    maturity_date
    annual_loan_payment
    cash_flow
    cash_on_cash
    dscr
    prepayment_penalty
    credits_at_closing
    referral
    referral_percent
    noi_percent
    referred_by_id
    referred_by_type
    referral_type
    hsc_financing
    date_created
    apn
    other_financing
    notes
    rep_agreement_file_1
    rep_agreement_file_2
    rep_agreement_file_3
    rep_agreement_file_4
    rep_agreement_file_5
    in_neg_file_1
    in_neg_file_2
    in_neg_file_3
    in_neg_file_4
    in_neg_file_5
    seller_statement_file
    buyer_statement_file
    website_photo_1
    website_photo_2
    website_photo_3
    website_photo_4
    website_photo_5
    created_by
    flagged_date
    under_contract_in_negotiation_since
    property_info_since
    off_market_since
    last_modified_by
    last_modified_date
    uploaded_from
    is_listing
    was_proposal
    estimated_price_type
    sub_category
    units
    proposal_date
    bank_bonus
    bank_bonus_percent
    arcimedes_created
    arcimedes_created_by
    arcimedes_modified
    arcimedes_modified_by
    agent_1_first_name
    agent_1_last_name
    agent_2_first_name
    agent_2_last_name
    agent_3_first_name
    agent_3_last_name
    agent_4_first_name
    agent_4_last_name
    sellers_first_name
    sellers_last_name
    lender_name
  }
}
`;
  // query v7PropertiesList($listOptions: ListOptions) {
  //   v7PropertiesList(listOptions: $listOptions) {
  //           arcimedes_row_id
  //           source
  //           status
  //           hsc_status
  //           name
  //           address
  //           city
  //           state
  //           latitude
  //           longitude
  //           type
  //           category
  //           sub_category
  //           units
  //           sqft
  //           list_price
  //           lease_type
  //           net_operating_income
  //           capitalization_rate
  //           sold_price
  //           close_of_escrow
  //           listed_date
  //           close_cap_rate
  //           close_noi
  //           proforma_cap_rate
  //           proforma_noi
  //           is_proforma_pricing
  //           close_price_per_sqft
  //           price_per_sqft
  //           year_built
  //           visible
  //           rent_per_sqft
  //           lease_expiration_date
  //           vacancy
  //           media_kit
  //           negotiation_price
  //           negotiation_cap_rate
  //           listing_agent_1
  //           listing_agent_2
  //           listing_agent_3
  //           buyer_agent_1
  //           buyer_agent_2
  //           buyer_agent_3
  //           website_photo_1
  //           negotiation_price_per_sqft
  //           down_payment
  //           seller_fee_percentage
  //           is_listing
  //           was_proposal
  //           effective_date
  //           hsc_financing
  //           hsc_price
  //           loan_amount
  //           loan_type
  //           last_modified_date
  //           loan_closing_date
  //           ltv
  //           interest_rate
  //           amortization
  //           term
  //   }
  // }


export const V7_PROPERTIES_STATS_ACTIVE_DEV = gql`
query v7PropertiesStatsActive($listOptions: ListOptions){
  v7PropertiesStatsActive(listOptions: $listOptions)
}
`
export const V7_PROPERTIES_STATS_QUERY = gql`
query v7PropertiesStats($pageOptions: PageOptions, $listOptions: ListOptions) {
  v7PropertiesStats(pageOptions: $pageOptions, listOptions: $listOptions)
}
`

export const V9_PROPERTIES_LIST = gql`
query v9PropertiesList($pageOptions: PageOptions, $listOptions: Options, $sortOptions: [SortOptions]) {
  v9PropertiesList(pageOptions: $pageOptions, listOptions: $listOptions, sortOptions: $sortOptions) {
    arcimedes_row_id
    deleted
    source
    transaction_type
    status
    visible
    featured
    strive_slider
    name
    address
    city
    state
    zip
    latitude
    longitude
    highlights
    media_kit
    type
    sqft
    list_price
    net_operating_income
    vacancy
    capitalization_rate
    sold_price
    down_payment
    close_of_escrow
    listed_date
    seller_fee_percentage
    total_fee
    lease_type
    lease_commencement_date
    lease_expiration_date
    seller_id
    buyer_id
    year_built
    video_url
    close_noi
    proforma_noi
    proforma_base_rent
    proforma_cap_rate
    close_cap_rate
    close_price_per_sqft
    price_per_sqft
    listing_agent_1
    listing_agent_2
    listing_agent_3
    listing_agent_4
    referring_listing_agent
    listing_agent_4_firm
    referring_listing_agent_firm
    buyer_agent_1
    buyer_agent_2
    buyer_agent_3
    buyer_agent_4
    referring_buyer_agent
    buyer_agent_4_firm
    referring_buyer_agent_firm
    listing_agent_1_percent
    listing_agent_2_percent
    listing_agent_3_percent
    listing_agent_4_percent
    referring_listing_agent_percent
    buyer_agent_1_percent
    buyer_agent_2_percent
    buyer_agent_3_percent
    buyer_agent_4_percent
    referring_buyer_agent_percent
    single_tenant_subcategory
    multi_tenant_subcategory
    tenant_id
    market
    rent_per_sqft
    negotiation_price
    potential_fee
    list_fee
    buyside_fee
    negotiation_cap_rate
    category
    hide_financials
    is_proforma_pricing
    date_removed
    negotiation_price_per_sqft
    base_rent
    expiration_no_of_months
    expiration_date
    effective_date
    referral_fee
    hsc_team_member_1
    hsc_team_member_1_percent
    hsc_team_member_1_net_fee
    hsc_team_member_1_net_percent
    hsc_team_member_1_gross_fee
    hsc_team_member_2
    hsc_team_member_2_percent
    hsc_team_member_2_net_fee
    hsc_team_member_2_net_percent
    hsc_team_member_2_gross_fee
    hsc_agreement_file
    loan_commitment_file
    closing_statement_file
    loan_closing_date
    hsc_approved
    hsc_approved_timestamp
    hsc_approved_initials
    hsc_status
    hsc_price
    hsc_listed_date
    hsc_expiration_no_of_months
    hsc_expiration_date
    hsc_fee_percentage
    hsc_total_fee
    hsc_list_fee
    lender_id
    loan_type
    ltv
    loan_amount
    interest_rate
    amortization
    term
    maturity_date
    annual_loan_payment
    cash_flow
    cash_on_cash
    dscr
    prepayment_penalty
    credits_at_closing
    referral
    referral_percent
    noi_percent
    referred_by_id
    referred_by_type
    referral_type
    hsc_financing
    date_created
    apn
    other_financing
    notes
    rep_agreement_file_1
    rep_agreement_file_2
    rep_agreement_file_3
    rep_agreement_file_4
    rep_agreement_file_5
    in_neg_file_1
    in_neg_file_2
    in_neg_file_3
    in_neg_file_4
    in_neg_file_5
    seller_statement_file
    buyer_statement_file
    website_photo_1
    website_photo_2
    website_photo_3
    website_photo_4
    website_photo_5
    created_by
    flagged_date
    under_contract_in_negotiation_since
    property_info_since
    off_market_since
    last_modified_by
    last_modified_date
    uploaded_from
    is_listing
    was_proposal
    estimated_price_type
    sub_category
    units
    proposal_date
    bank_bonus
    bank_bonus_percent
    arcimedes_created
    arcimedes_created_by
    arcimedes_modified
    arcimedes_modified_by
    agent_1_first_name
    agent_1_last_name
    agent_2_first_name
    agent_2_last_name
    agent_3_first_name
    agent_3_last_name
    agent_4_first_name
    agent_4_last_name
    sellers_first_name
    sellers_last_name
    lender_name
  }}`
 


 export const V9_PROPERTIES_STATS_ACTIVE = gql`
query v9PropertiesStatsActive($listOptions: Options){
  v9PropertiesStatsActive(listOptions: $listOptions)
}
`
export const V9_PROPERTIES_STAT_COUNT = gql`
  query v9PropertiesStatsCount($listOptions: Options) {
    v9PropertiesStatsCount(listOptions: $listOptions)
  }
`;

export const V10_PROPERTIES_LIST = gql`
query v10PropertiesList($pageOptions: PageOptions, $listOptions: Options, $sortOptions: [SortOptions]) {
  v10PropertiesList(pageOptions: $pageOptions, listOptions: $listOptions, sortOptions: $sortOptions) {
    arcimedes_row_id
    deleted
    source
    transaction_type
    status
    visible
    featured
    strive_slider
    name
    address
    city
    state
    zip
    latitude
    longitude
    highlights
    media_kit
    type
    sqft
    list_price
    net_operating_income
    vacancy
    capitalization_rate
    sold_price
    down_payment
    close_of_escrow
    listed_date
    seller_fee_percentage
    total_fee
    lease_type
    lease_commencement_date
    lease_expiration_date
    seller_id
    buyer_id
    year_built
    video_url
    close_noi
    proforma_noi
    proforma_base_rent
    proforma_cap_rate
    close_cap_rate
    close_price_per_sqft
    price_per_sqft
    listing_agent_1
    listing_agent_2
    listing_agent_3
    listing_agent_4
    referring_listing_agent
    listing_agent_4_firm
    referring_listing_agent_firm
    buyer_agent_1
    buyer_agent_2
    buyer_agent_3
    buyer_agent_4
    referring_buyer_agent
    buyer_agent_4_firm
    referring_buyer_agent_firm
    listing_agent_1_percent
    listing_agent_2_percent
    listing_agent_3_percent
    listing_agent_4_percent
    referring_listing_agent_percent
    buyer_agent_1_percent
    buyer_agent_2_percent
    buyer_agent_3_percent
    buyer_agent_4_percent
    referring_buyer_agent_percent
    single_tenant_subcategory
    multi_tenant_subcategory
    tenant_id
    market
    rent_per_sqft
    negotiation_price
    potential_fee
    list_fee
    buyside_fee
    negotiation_cap_rate
    category
    hide_financials
    is_proforma_pricing
    date_removed
    negotiation_price_per_sqft
    base_rent
    expiration_no_of_months
    expiration_date
    effective_date
    referral_fee
    hsc_team_member_1
    hsc_team_member_1_percent
    hsc_team_member_1_net_fee
    hsc_team_member_1_net_percent
    hsc_team_member_1_gross_fee
    hsc_team_member_2
    hsc_team_member_2_percent
    hsc_team_member_2_net_fee
    hsc_team_member_2_net_percent
    hsc_team_member_2_gross_fee
    hsc_agreement_file
    loan_commitment_file
    closing_statement_file
    loan_closing_date
    hsc_approved
    hsc_approved_timestamp
    hsc_approved_initials
    hsc_status
    hsc_price
    hsc_listed_date
    hsc_expiration_no_of_months
    hsc_expiration_date
    hsc_fee_percentage
    hsc_total_fee
    hsc_list_fee
    lender_id
    loan_type
    ltv
    loan_amount
    interest_rate
    amortization
    term
    maturity_date
    annual_loan_payment
    cash_flow
    cash_on_cash
    dscr
    prepayment_penalty
    credits_at_closing
    referral
    referral_percent
    noi_percent
    referred_by_id
    referred_by_type
    referral_type
    hsc_financing
    date_created
    apn
    other_financing
    notes
    rep_agreement_file_1
    rep_agreement_file_2
    rep_agreement_file_3
    rep_agreement_file_4
    rep_agreement_file_5
    in_neg_file_1
    in_neg_file_2
    in_neg_file_3
    in_neg_file_4
    in_neg_file_5
    seller_statement_file
    buyer_statement_file
    website_photo_1
    website_photo_2
    website_photo_3
    website_photo_4
    website_photo_5
    created_by
    flagged_date
    under_contract_in_negotiation_since
    property_info_since
    off_market_since
    last_modified_by
    last_modified_date
    uploaded_from
    is_listing
    was_proposal
    estimated_price_type
    sub_category
    units
    proposal_date
    bank_bonus
    bank_bonus_percent
    arcimedes_created
    arcimedes_created_by
    arcimedes_modified
    arcimedes_modified_by
    agent_1_first_name
    agent_1_last_name
    agent_2_first_name
    agent_2_last_name
    agent_3_first_name
    agent_3_last_name
    agent_4_first_name
    agent_4_last_name
    sellers_first_name
    sellers_last_name
    lender_name
  }}`
 


 export const V10_PROPERTIES_STATS_ACTIVE = gql`
query v10PropertiesStatsActive($listOptions: Options){
  v10PropertiesStatsActive(listOptions: $listOptions)
}
`
export const V10_PROPERTIES_STAT_COUNT = gql`
  query v10PropertiesStatsCount($listOptions: Options) {
    v10PropertiesStatsCount(listOptions: $listOptions)
  }
`;

 

export const V7_PROPERTIES_STAT_COUNT = gql`
  query v7PropertiesStatsCount($listOptions: ListOptions) {
    v7PropertiesStatsCount(listOptions: $listOptions)
  }
`;

// CRUDProperty.js Queries

export const GET_ALL_TENANTS = gql`
  query getTenents {
    getTenents {
      tenents {
        arcimedes_row_id
        name
      }
    }
  }
`;
//
export const GET_TEAM = gql`
  query getTeamMembers($filters: [Filters], $sortOptions: [SortOptions]) {
    getTeamMembers(filters: $filters, sortOptions: $sortOptions) {
      teamMember {
        arcimedes_row_id
        deleted
        first_name
        is_agent
        last_name
      }
    }
  }
`;
//
export const GET_PROPERTY_UNDERWRITING_TENANTS = gql`
  query getUnderwritingTenent($propertyId: ID!) {
    getUnderwritingTenent(property_id: $propertyId) {
    arcimedes_row_id
    deleted
    property_id
    tenant_row_id
    tenant_id
    tenant_name
    rr_suite_code
    rr_sqft
    rr_start_date
    rr_end_date
    rr_monthly_rent
    rr_escalation_date
    rr_escalation_monthly_rent
    rr_options
    rr_option_1_rent
    rr_option_2_rent
    rr_option_3_rent
    rr_option_4_rent
    rr_option_5_rent
    rr_notes
    proforma_rr_tenant_name
    proforma_rr_sqft
    proforma_rr_start_date
    proforma_rr_end_date
    proforma_rr_psf
    proforma_ti_sf
    proforma_lc
    reimb_code
    reimb_annual_other
    reimb_notes
    reimb_annual_other_1
    reimb_monthly_ret
    reimb_monthly_ins
    reimb_monthly_cam
    reimb_monthly_other
    proforma_reimb_code
    }
}
`
export const GET_PROPERTY_UNDERWRITING_SINGLE_TENANTS = gql`
query GetUnderwritingSingleTenent($arcimedesRowId: ID!) {
  getUnderwritingSingleTenent(arcimedes_row_id: $arcimedesRowId) {
    arcimedes_row_id
    property_id
    cad_link
    appraised_value
    analysis_date
    sale_lease_back
    price_psf
    lot_size
    original_lease_term
    increases
    guarantor
    options
    options_to_purchase
    pricing_range_bps_change
    pricing_range_price_psf_change
    loan_info_down_payment
    loan_info_interest_rate
    loan_info_amortization
    addition_type
    addition_value
    addition_type2
    addition_value2
    addition_type3
    addition_value3
    addition_type4
    addition_value4
    lease_notes
    clear_height
    doors
    office_to_warehouse
    arcimedes_created
    arcimedes_created_by
    arcimedes_modified
    arcimedes_modified_by
  }
}
`
export const GET_UNDERWRITING_SINGLE_TENANT_WITH_PROPERTYID= gql`
query GetUnderwritingSingleTenent($propertyId: ID) {
  getUnderwritingSingleTenent(property_id: $propertyId) {
    arcimedes_row_id
    property_id
    cad_link
    appraised_value
    analysis_date
    sale_lease_back
    price_psf
    lot_size
    original_lease_term
    increases
    guarantor
    options
    options_to_purchase
    pricing_range_bps_change
    pricing_range_price_psf_change
    loan_info_down_payment
    loan_info_interest_rate
    loan_info_amortization
    addition_type
    addition_value
    addition_type2
    addition_value2
    addition_type3
    addition_value3
    addition_type4
    addition_value4
    lease_notes
    clear_height
    doors
    office_to_warehouse
    arcimedes_created
    arcimedes_created_by
    arcimedes_modified
    arcimedes_modified_by
  }
}
`
export const GET_UNDERWRITING_MULTI_TENANT_WITH_PROPERTYID= gql`
query GetUnderwritingMultiTenent($propertyId: ID) {
  getUnderwritingMultiTenent(property_id: $propertyId) {
    arcimedes_row_id
    property_id
    lot_size
    current_tax_appraised_value
    current_tax_liability
    google_maps_link
    cad_link_1
    cad_link_2
    cad_link_3
    cad_link_4
    as_is_checkbox
    proforma_checkbox
    assumable_loan_checkbox
    analysis_date
    additional_price_type
    additional_price
    principal_balance
    proforma_principal_balance
    loan_amount
    proforma_loan_amount
    down_payment
    proforma_down_payment
    down_payment_percent
    proforma_down_payment_percent
    vacancy_factor
    proforma_yield
    interest_rate
    proforma_interest_rate
    amortization
    proforma_amortization
    pricing_bps_increase
    pricing_bps_increase_pro
    current_real_estate_taxes
    current_insurance
    current_non_reimb_expenses
    current_rr_end_months
    current_rr_term
    current_rr_notes
    expenses_management_fee_of_gpi
    expenses_current_year
    expenses_notes
    proforma_vacancy_factor
    proforma_real_estate_taxes
    proforma_insurance
    proforma_non_reimb_expenses
    proforma_mgmt_fee_of_gpi
    map_image
    reimb_types_manually_modified
    proforma_additional_price
    proforma_analysis_date
    annual_other_income
    arcimedes_created
    arcimedes_created_by
    arcimedes_modified
    arcimedes_modified_by
  }
}
`
export const GET_UNDERWRITING_TENENT_TYPE = gql`
query GetUnderwritingTenentType($propertyId: ID) {
  getUnderwritingTenentType(property_id: $propertyId) {
    arcimedes_row_id
    deleted
    property_id
    reimb_types_index
    reimb_types_description
    reimb_types_cam_increase
    reimb_types_has_cam
    reimb_types_cam_value
    reimb_types_mgmt_fee_value
    reimb_types_has_management_fee
    reimb_types_has_insurance
    reimb_types_insurance_value
    reimb_types_has_taxes
    reimb_types_taxes_value
    pro_forma_reimb_types_description
    pro_forma_reimb_types_cam_increase
    pro_forma_reimb_types_has_cam
    pro_forma_reimb_types_cam_value
    pro_forma_reimb_types_mgmt_fee_value
    pro_forma_reimb_types_has_management_fee
    pro_forma_reimb_types_has_insurance
    pro_forma_reimb_types_insurance_value
    pro_forma_reimb_types_has_taxes
    pro_forma_reimb_types_taxes_value
    arcimedes_created
    arcimedes_created_by
    arcimedes_modified
    arcimedes_modified_by
  }
}
`
export const GET_UNDERWRITING_EXPENSES_CAM = gql`
query GetUnderwritingExpensesCam($propertyId: ID) {
  getUnderwritingExpensesCam(property_id: $propertyId) {
    arcimedes_row_id
    property_id
    cam_index
    deleted
    cam_name
    cam_value
    proforma_cam_value
    arcimedes_created
    arcimedes_created_by
    arcimedes_modified
    arcimedes_modified_by
  }
}
`
export const CREATE_UPDATE_UNDERWRITING_PARCELS = gql`
mutation CreateOrUpdateUnderwritingParcel($input: [UnderwritinParcelsInput]) {
  createOrUpdateUnderwritingParcel(input: $input) {
    success
    message
    data {
      arcimedes_row_id
      property_id
      parcel
      assessed_value
      tax_liability
      arcimedes_created
      arcimedes_created_by
      arcimedes_modified
      arcimedes_modified_by
    }
    error
  }
}
`

export const GET_UNDERWRITING_PARCELS = gql`
query GetUnderwritingParcel($propertyId: ID) {
  getUnderwritingParcel(property_id: $propertyId) {
    arcimedes_row_id
    property_id
    parcel
    assessed_value
    tax_liability
    arcimedes_created
    arcimedes_created_by
    arcimedes_modified
    arcimedes_modified_by
  }
}
`
export const GET_UNDERWRITING_RENT_SCHEDULE = gql`
query GetUnderwritingRentSchedule($propertyId: ID) {
  getUnderwritingRentSchedule(property_id: $propertyId) {
    arcimedes_row_id
    property_id
    deleted
    years
    lease_commencement
    monthly_rent
    arcimedes_created
    arcimedes_created_by
    arcimedes_modified
    arcimedes_modified_by
  }
}
`
export const GET_ESCROW_TRACKING = gql`
  query GetStriveEscrowTrack($propertyId: ID!) {
    GetStriveEscrowTrack(propertyId: $propertyId) {
      arcimedes_row_id
      property_id
      deleted
      task
      title_company
      escrow_officer
      psa_sent_to_buyer
      psa_sent_to_buyer_checkbox
      have_all_due_diligence_materials
      effective_date
      effective_date_checkbox
      rofr_notice_sent_to_tenant
      rofr_notice_sent_to_tenant_checkbox
      rofr_waiver_sent_to_buyerside__title_co
      rofr_waiver_sent_to_buyerside__title_co_checkbox
      psa_sent_to_title
      psa_sent_to_title_checkbox
      survey_sent_to_title
      survey_sent_to_title_checkbox
      receipted_psa_received__sent_to_buyers_agent
      receipted_psa_received__sent_to_buyers_agent_checkbox
      dd_site_created__access_granted
      dd_site_created__access_granted_checkbox
      updated_db__istrive
      updated_to_uc_on_externals
      wiring_instructions_sent_to_buyeragent
      earnest_money_received
      earnest_money_received_checkbox
      has_title_approved_survey
      survey_ordered
      survey_ordered_checkbox
      received_title_commitment
      received_title_commitment_checkbox
      buyers_title_objections_due
      buyers_title_objections_due_checkbox
      seller_response_to_buyer_objections
      seller_response_to_buyer_objections_checkbox
      title_objection_period
      title_objection_period_checkbox
      financing_application_deadline
      financing_application_deadline_checkbox
      feasibility_period
      feasibility_extension
      feasibility_period_expires__deposit_nonrefundable
      feasibility_period_expires__deposit_nonrefundable_checkbox
      financing_approval
      financing_approval_checkbox
      financing_period_ends
      financing_period_ends_checkbox
      additional_earnest_money_received
      additional_earnest_money_received_checkbox
      estoppelsnda_requested_from_lender_buyer_or_tenant
      estoppelsnda_requested_from_lender_buyer_or_tenant_checkbox
      estoppelssdna_due
      estoppelssdna_due_checkbox
      verify_close_10_days_before_closing
      verify_close_10_days_before_closing_checkbox
      send_title_invoice_wire_cam_deposits_prorations
      send_title_invoice_wire_cam_deposits_prorations_checkbox
      update_insurance_certificates
      update_insurance_certificates_checkbox
      title_sent_out_closing_statements_for_review
      title_sent_out_closing_statements_for_review_checkbox
      closing_period
      closing_extension
      closing_date
      closing_date_checkbox
      arcimedes_created
      arcimedes_created_by
      arcimedes_modified
      arcimedes_modified_by
    }
}
`
export const GET_PROPERTY_WEBSITE_USERS = gql`
query GetWebsiteUser($propertyId: ID, $propertyIdFirst: String, $propertyIdLast: String, $propertyIdMid: String, $arcimedesRowId: ID) {
  getWebsiteUser(property_id: $propertyId, property_id_first: $propertyIdFirst, property_id_last: $propertyIdLast, property_id_mid: $propertyIdMid, arcimedes_row_id: $arcimedesRowId) {
    arcimedes_row_id
    email
    first_name
    last_name
    company_name
    is_principal
    is_broker
    phone
    packages_id
    arcimedes_created
    arcimedes_created_by
    arcimedes_modified
    arcimedes_modified_by
  }
}
`
export const GET_PROPERTY_DATA = gql`
  query getpropertyQuery($arcimedesRowId: ID!) {
    getpropertyQuery(arcimedes_row_id: $arcimedesRowId)
  }
`;
// $pageOptions: PageOptions,$filters: [Filters], $sortOptions: [SortOptions]
// pageOptions: $pageOptions, filters: $filters, sortOptions: $sortOptions

export const GET_PROPERTY_HISTORY = gql`
query propertyHistoryQuery($propertyId: ID) {
  propertyHistoryQuery(property_id: $propertyId)
}
  `
// query propertyHistoryQuery($propertyId: ID!) {
//   propertyHistoryQuery( property_id: $propertyId) 
// }
// `
// export const GET_PROPERTY_HISTORY = gql`
// query getPropertyHistory($arcimedes_row_id: ID!) {
//   getPropertyHistory(arcimedes_row_id: $arcimedes_row_id) {
//     arcimedes_row_id
//     base_rent

//     cap_rate
//     date

//     net_operating_income
//     price
//     price_per_sqft
//     rent_per_sqft

//     status
//     vacancy
//     }
// }
// `
export const GET_HSC_LOAN_QUOTES = gql`
  query getHscLoanQuote($propertyId: ID!) {
    getHscLoanQuote(property_id: $propertyId) {
      arcimedes_row_id
      property_id
      loan_structure
      purchase_price
      down_payment_percent
      down_payment
      loan_amount
      interest_rate
      loan_term
      maturity
      amortization
      prepayment_penalty
      loan_payment_monthly
      loan_payment_annually
      cap_rate
      noi
      cash_flow_monthly
      cash_flow_annually
      cash_on_cash
      notes
      noi_multiplied
      dscr
      debt_yield
      bank
      bank_contact
      deleted
      noi_percentage
      recourse
      total_origination_fee
      is_printable
      print_page_number
      autopopulate
      loan_quotes_order
      arcimedes_created
      arcimedes_created_by
      arcimedes_modified
      arcimedes_modified_by
    }
  }
`;

export const GET_PROPERTY_PAYMENT_TEAM = gql`
  query getPropertyPaymentTeam($propertyId: ID!) {
    getPropertyPaymentTeam(property_id: $propertyId) {
      arcimedes_row_id
      property_id
      strive_team_member_id
      strive_team_member_percent
      strive_team_member_gross_fee
      strive_team_member_net_fee
      strive_team_member_net_percent
    }
  }
`;

export const GET_PROPOSAL = gql`
  query getProposal($propertyId: ID!) {
    getProposal(property_id: $propertyId) {
      arcimedes_row_id
      property_id
      strengths
      challenges
      buyer_pool
      qualifications
      recommendations
    }
  }
`;

export const GET_SELLER = gql`
  query getSeller($arcimedes_row_id: ID!) {
    getSeller(arcimedes_row_id: $arcimedes_row_id) {
      arcimedes_row_id
      property_id
      strengths
      challenges
      buyer_pool
      qualifications
      recommendations
    }
  }
`;

export const GET_HSC_TRACKING = gql`
  query getHscTracking($filter: [FilterInput!]) {
    getHscTracking(filter: $filter) {
      needToAdd
    }
  }
`;

export const GET_AGENT_GROSS_CUMULATIVE = gql`
query getAgentGrossCumulative($currentTeamMember: String!, $closeOfEscrow: String!) {
  getAgentGrossCumulative(currentTeamMember: $currentTeamMember, closeOfEscrow: $closeOfEscrow) {
    buyingProcuredGrossCumulative
    listingProcuredGrossCumulative
  }
}
`;

export const GET_HSC_AGENT_CUMULATIVE = gql`
query HscAgentGrossCumulative($hscTeamMember: String!, $date: String!, $currentProperty: String!) {
  hscAgentGrossCumulative(hscTeamMember: $hscTeamMember, date: $date, currentProperty: $currentProperty) {
    hscAgentGrossCumulative
  }
}
`

export const GET_PAYMENT_PROPERTIES = gql`
query GetPropertyPayments($coe: String, $propertyId: String) {
  getPropertyPayments(coe: $coe, property_id: $propertyId) {
    arcimedes_row_id
    strive_teamMember_id
    strive_teamMember_percent
    strive_teamMember_gross_fee
    strive_teamMember_net_fee
    property_id
    listing_percentage
    buying_percentage
    listing_gross_commission
    buying_gross_commission
    close_of_escrow
  }
}
`

export const GET_AGENT_COMMISSION_PAID = gql`
query agentCommissionPaid($options: AgentOptions) {
  agentCommissionPaid(options: $options)
}
`

export const GET_AGENT_COMMISSION_PROCURED = gql`
query agentCommissionProcured($agentId: Int!, $year: Int!) {
  agentCommissionProcured(agentId: $agentId, year: $year)
}
`
export const GET_PROPERTY_NOTES = gql`
 query GetPropertyNotes($propertyId: Float, $lat: Float, $lng: Float) {
  getPropertyNotes(property_id: $propertyId, lat: $lat, lng: $lng) {
    success
    message
    data {
      ARCIMEDES_ROW_ID
      PROPERTY_ID
      NOTES
      ADDRESS
      LATITUDE
      LONGITUDE
      DELETED
      CREATED
      MODIFIED
      CREATED_BY
      MODIFIED_BY
    }
    error
  }
}
`;

export const GET_PROPERTY_OWNER = gql`
  query GetPropertyOwner($lat: Float!, $lng: Float!) {
    getPropertyOwner(lat: $lat, lng: $lng) {
      data {
        contact_id
        contact_type
        arcimedes_row_id
        first_name
        last_name
        notes
        email
        phone
      }
    }
  }
`;


export const V7_PROPERTIES_MAP_QUERY = gql`
query V7PropertiesMap($listOptions: ListOptions, $pageOptions: PageOptions) {
  v7PropertiesMap(listOptions: $listOptions, pageOptions: $pageOptions) {
    arcimedes_row_id
    deleted
    source
    transaction_type
    status
    visible
    featured
    strive_slider
    name
    address
    city
    state
    zip
    latitude
    longitude
    highlights
    media_kit
    type
    sqft
    list_price
    net_operating_income
    vacancy
    capitalization_rate
    sold_price
    down_payment
    close_of_escrow
    listed_date
    seller_fee_percentage
    total_fee
    lease_type
    lease_commencement_date
    lease_expiration_date
    seller_id
    buyer_id
    year_built
    video_url
    close_noi
    proforma_noi
    proforma_base_rent
    proforma_cap_rate
    close_cap_rate
    close_price_per_sqft
    price_per_sqft
    listing_agent_1
    listing_agent_2
    listing_agent_3
    listing_agent_4
    referring_listing_agent
    listing_agent_4_firm
    referring_listing_agent_firm
    buyer_agent_1
    buyer_agent_2
    buyer_agent_3
    buyer_agent_4
    referring_buyer_agent
    buyer_agent_4_firm
    referring_buyer_agent_firm
    listing_agent_1_percent
    listing_agent_2_percent
    listing_agent_3_percent
    listing_agent_4_percent
    referring_listing_agent_percent
    buyer_agent_1_percent
    buyer_agent_2_percent
    buyer_agent_3_percent
    buyer_agent_4_percent
    referring_buyer_agent_percent
    single_tenant_subcategory
    multi_tenant_subcategory
    tenant_id
    market
    rent_per_sqft
    negotiation_price
    potential_fee
    list_fee
    buyside_fee
    negotiation_cap_rate
    category
    hide_financials
    is_proforma_pricing
    date_removed
    negotiation_price_per_sqft
    base_rent
    expiration_no_of_months
    expiration_date
    effective_date
    referral_fee
    hsc_team_member_1
    hsc_team_member_1_percent
    hsc_team_member_1_net_fee
    hsc_team_member_1_net_percent
    hsc_team_member_1_gross_fee
    hsc_team_member_2
    hsc_team_member_2_percent
    hsc_team_member_2_net_fee
    hsc_team_member_2_net_percent
    hsc_team_member_2_gross_fee
    hsc_agreement_file
    loan_commitment_file
    closing_statement_file
    loan_closing_date
    hsc_approved
    hsc_approved_timestamp
    hsc_approved_initials
    hsc_status
    hsc_price
    hsc_listed_date
    hsc_expiration_no_of_months
    hsc_expiration_date
    hsc_fee_percentage
    hsc_total_fee
    hsc_list_fee
    lender_id
    loan_type
    ltv
    loan_amount
    interest_rate
    amortization
    term
    maturity_date
    annual_loan_payment
    cash_flow
    cash_on_cash
    dscr
    prepayment_penalty
    credits_at_closing
    referral
    referral_percent
    noi_percent
    referred_by_id
    referred_by_type
    referral_type
    hsc_financing
    date_created
    apn
    other_financing
    notes
    rep_agreement_file_1
    rep_agreement_file_2
    rep_agreement_file_3
    rep_agreement_file_4
    rep_agreement_file_5
    in_neg_file_1
    in_neg_file_2
    in_neg_file_3
    in_neg_file_4
    in_neg_file_5
    seller_statement_file
    buyer_statement_file
    website_photo_1
    website_photo_2
    website_photo_3
    website_photo_4
    website_photo_5
    created_by
    flagged_date
    under_contract_in_negotiation_since
    property_info_since
    off_market_since
    last_modified_by
    last_modified_date
    uploaded_from
    is_listing
    was_proposal
    estimated_price_type
    sub_category
    units
    proposal_date
    bank_bonus
    bank_bonus_percent
    arcimedes_created
    arcimedes_created_by
    arcimedes_modified
    arcimedes_modified_by
    agent_1_first_name
    agent_1_last_name
    agent_2_first_name
    agent_2_last_name
    agent_3_first_name
    agent_3_last_name
    agent_4_first_name
    agent_4_last_name
    sellers_first_name
    sellers_last_name
    lender_name
  }
}
`

export const GET_MAP_TEAM_MEMBER_QUERY = gql`
query GetTeamMembers($filters: [Filters], $sortOptions: [SortOptions]) {
  getTeamMembers(filters: $filters, sortOptions: $sortOptions) {
    teamMember {
      arcimedes_row_id
      first_name
      last_name
      title
      phone
      linkedin
      email
      description
      photo
      credentials
      is_agent
      deleted
      is_admin
      visible_on_website
      starting_date
      termination_date
      yrs_at_strive
      birth_date
      age
      on_phones
      in_pool
      first_listing
      first_closing
      address
      city
      state
      zip
      cell_phone
      territory
      w4_form
      w9_form
      payroll_form
      ca_form
      it_policy_form
      trade_secrets_form
      arcimedes_created
      arcimedes_created_by
      arcimedes_modified
      arcimedes_modified_by
    }
    totalCount
  }
}

`
export const GET_BUYER_STATE_BREAKDOWN = gql`
query GetPropertiesByBuyerState($listOptions: ListOptions) {
  getPropertiesByBuyerState(listOptions: $listOptions) {
    company_state
    total_properties
  }
}
`
export const GET_TEXAS_TOTAL_TRANSACTIONS = gql`
  query GetTexasTotalTransactions($options: TexasOptions) {
    getTexasTotalTransactions(options: $options){
      count
    }
  }`
export const GET_TEXAS_REGION_TRANSACTIONS = gql`
query GetTexasRegionTransactions($options: TexasOptions) {
  getTexasRegionTransactions(options: $options){
    count
    market
  }
}`
export const GET_BUYERS_LOCATION = gql`
query GetBuyersLocation($options: TexasOptions) {
  getBuyersLocation(options: $options){
    company_state
    total_properties
  }
}`
export const GET_BUYERS_LOCATION_TOTAL = gql`
query GetBuyersLocationTotal($options: TexasOptions) {
  getBuyersLocationTotal(options: $options){
    total_properties
  }
}`
export const GET_TEXAS_MARKET_TRANSACTIONS = gql`
query GetTexasMarketTransactions($options: TexasOptions) {
  getTexasMarketTransactions(options: $options){
    count
    price
    cap_rate
    list_cap_rate
    delta_list_to_sell
    price_psf
    rent_psf
    occupancy
  }
}`
export const GET_TEXAS_MARKET_SHARE = gql`
query GetTexasMarketShare($options: TexasOptions) {
  getTexasMarketShare(options: $options){
    count
    price
    cap_rate
    list_cap_rate
    delta_list_to_sell
    price_psf
    rent_psf
    occupancy
  }
}`

export const GET_PROPERTIES_ADDRESS = gql`
query PropertiesAddess($input: AddressInput) {
  propertiesAddess(input: $input) {
    arcimedes_row_id
    address
    city
  }
}`

// export const GET_PROPERTY_BY_COORDS = gql`
// query GetPropertyByCoords($lat: Float!, $lng: Float!, $address: String!) {
//   getPropertyByCoords(lat: $lat, lng: $lng, address: $address) 
// }`

export const GET_PROPERTY_BY_COORDS = gql`
query GetPropertyByCoords($filters: ListOptions) {
  getPropertyByCoords(filters: $filters) 
}`